import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchPellets } from "Thunks";

import PelletComponent from "./PelletComponent";

class PelletContainer extends Component {
  componentDidMount() {
    const { fetchPellets } = this.props;

    fetchPellets({ limit: 1 });
  }

  render() {
    return <PelletComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({
  pellets: state.pellets.items,
  fetching: state.pellets.fetching,
  fetched: state.pellets.fetched,
  selectedOrg: state.pellets.pelletSelectedOrg
});

const mapDispatchToProps = dispatch => ({
  fetchPellets: type => dispatch(fetchPellets(type))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PelletContainer);



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Pellet/PelletContainer.js